import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';

export default {
  data() {
    return {
      language: lang
    };
  },
  components: { Datepicker },
  methods: {
    getTime(end) {
      let hh = new Date().getHours();
      let mm = new Date().getMinutes();
      if (mm < 10) {
        mm = `0${mm}`;
      }
      if (end) {
        hh += 4;
        mm += 5;
        if (hh < 10) {
          hh = `0${hh}`;
        }
        if (hh >= 24) {
          hh = '00';
        }

        return hh + ':' + mm;
      }
      if (hh < 10) {
        hh = `0${hh}`;
      }
      return hh + ':' + mm;
    }
  }
};
